import Vue from "vue";
import Login from "@/views/login/Login";
import Layout from "@/views/layout/Layout.vue";
import UPSRouter from "./modules/UPS";
import motorRouter from "./modules/motor";

export default [
  {
    path: "/",
    redirect: Vue.siamEnabled ? null : "/login"
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/404",
    hidden: true,
    component: resolve => require(["@/views/error/404.vue"], resolve)
  },
  UPSRouter,
  motorRouter,
  {
    path: "/system",
    redirect: "/system/index",
    name: "system",
    component: Layout,
    meta: { title: "系统设置" },
    children: [
      {
        path: "/sys/userManagement",
        name: "userManagement",
        component: resolve =>
          require([
            "../views/system/userManagement/UserManagement.vue"
          ], resolve),
        meta: {
          title: "用户管理"
          // requireAuth: true,
        }
      },
      {
        path: "/sys/department",
        name: "department",
        component: resolve =>
          require(["../views/system/department/Department.vue"], resolve),
        meta: {
          title: "部门管理",
          requireAuth: true
        }
      },
      {
        path: "/sys/roleManagement",
        name: "roleManagement",
        component: resolve =>
          require([
            "../views/system/roleManagement/RoleManagement.vue"
          ], resolve),
        meta: {
          title: "角色管理",
          requireAuth: true
        }
      },
      {
        path: "/sys/menuManagement",
        name: "menuManagement",
        component: resolve =>
          require([
            "../views/system/menuManagement/MenuManagement1.vue"
          ], resolve),
        meta: {
          title: "菜单管理",
          requireAuth: true
        }
      },
      {
        path: "/messageInfo",
        name: "messageInfo",
        component: resolve =>
          require(["../views/messageCenter/messageInfo.vue"], resolve),
        meta: {
          title: "待办事项",
          requireAuth: true
        }
      }
    ]
  },
  { path: "*", redirect: "/404", hidden: true }
];



// WEBPACK FOOTER //
// ./src/router/index.js